import { HttpHandler } from 'msw'

import { activateAccount } from './activateAccount'
import { askResetPassword } from './askResetPassword'
import { login } from './login'
import { me } from './me'
import { refreshTokens } from './refreshTokens'
import { register } from './register'
import { resetPassword } from './resetPassword'

export const auth: HttpHandler[] = [
    activateAccount,
    askResetPassword,
    login,
    me,
    refreshTokens,
    register,
    resetPassword,
]
